/*================================
	
	＊＊已經與原先cupoy-image不太一樣了，多一些功能＊＊

	補上放大鏡功能，see cupoyZoom
		Author : Gray
		更新時間 : 2017 / 08 / 30
	
	之前Cupoy無lazy load，這邊 補上lazy load
		Author : Gray
		更新時間 : 2016 / 08 / 22

================================*/

/*================================

	將所有image相關的載入邏輯寫在一起

	1. fallback image：
		試圖載入指定的URL圖檔，若失敗則改用預設的縮圖網址
	2. lazy loading image:
		如果該element不在viewport中，先不要載入
	3. image fade in
		當圖片第一次進入viewport的時候，進行fade in動畫

	Author : egg
	最後更新時間 : 2015 / 09 / 08

================================*/

window.InifECShared.directive('cupoyImage', ['$timeout', 'cupoyImageURLCache',
	function($timeout, cupoyImageURLCache) {

		var uniqueId = 0;

		return {
			restrict: "AE",
			link: function(scope, element, attrs) {

				var cupoyImageId = uniqueId++;
				var isLazy = attrs.lazyLoad == 'true';
				var isZoomImage = attrs.cupoyZoom != undefined && attrs.cupoyZoom != "about:blank";
				var enterViewportWatcher = undefined;

				if(isLazy) {
					enterViewportWatcher = scrollMonitor.create(element);

					// 檢查是否在viewport中, 是的話才預載圖片
					enterViewportWatcher.enterViewport(function() {
						// 先等一段時間，在非連續scroll的狀態下也就是畫面靜止了才開始載入圖片
						requestAnimationFrame(function(){
							if(enterViewportWatcher.isInViewport) {
								onImageSrcChange();
							}
						});
					});
				} else {
					// watch cupoy image
					scope.$watch(attrs.cupoyImage, function(newValue, oldValue) {
						onImageSrcChange();			
					});
				}

				var isPreloading = false;
				// var isLoading = false;
				var preloadingURL;
				var preloadingImage;

				var cache = cupoyImageURLCache;
				var isBGImage = element[0].tagName !== 'IMG';


				if (isBGImage) {
					element.css('will-change', 'transform');
				}

				var onImageSrcChange = function(){

					// 清掉原本的圖
					// loadImage('about:blank');
					element.removeClass('show');

					var imagesrc = scope.$eval(attrs.cupoyImage);

					if(attrs.useLatest == 'true' && imagesrc) {
						// 補上更新時間，避免抓到舊圖
						if(imagesrc.indexOf("?") == -1) {
						    imagesrc += '?t=' + TIMESTAMP;
						} else {
						    imagesrc += '&t=' + TIMESTAMP;
						}
					}
				
					if(isPreloading){
						// console.log("cupoy image src changed during preloading");
						// check if imagesrc were the same
						if(preloadingURL !== imagesrc){
							// abort preloading/loading
							preloadingImage.onload = undefined;
							preloadingImage.onerror = undefined;
							preloadingImage = undefined;
							isPreloading = false;
							preloadingURL = undefined;
							// console.log('abort preloading');
						}
					}

					// 沒有給source url就什麼也不做
					if (!imagesrc || imagesrc === 'about:blank'){
						if (isBGImage) {
							element.css('background-image', 'url(about:blank)');
						} else {
							element.attr('src', "about:blank");
						}
						return;
					}

					imagesrc = imagesrc.replace('https://', '//');
					imagesrc = imagesrc.replace('http://', '//');

					if(imagesrc.indexOf("//") == 0 && location.protocol.indexOf("file") == 0){
            			imagesrc = "http:" + imagesrc;
        			}	
					// console.log('imagesrc changed to ' + imagesrc);

					var cachekey = imagesrc;
					// check if we have cached url 
					if (cache.get(cachekey)) {
						// console.log('image url has been loaded key = ' + cachekey + ', value = ' + cache.get(cachekey));
						imagesrc = cache.get(cachekey);
						loadImage(imagesrc);
						return;
					}
					requestAnimationFrame(function() {
						preloadImage(imagesrc);
					})
				}

				var loadImage = function(imagesrc) {
					// isLoading = true;
					if (isBGImage) {
						// 啟動fade in css
						// requestAnimationFrame(function(){
						element.css('background-image', 'url(' + imagesrc + ')');
						element.addClass('show');
						enterViewportWatcher && enterViewportWatcher.destroy();
					} else {
						// 啟動fade in css
						// requestAnimationFrame(function(){
						element.attr('src', imagesrc);
						element.addClass('show');
						enterViewportWatcher && enterViewportWatcher.destroy();
					}
					// isLoading = false;

					if(isZoomImage) {
						initZoomImage();
					}
				};

				var preloadImage = function(imagesrc) {
					isPreloading = true;
					preloadingURL = imagesrc;
					var image = new Image();
					preloadingImage = image;
					image.src = imagesrc;
					var srcfinalized = false;
					var cachekey = imagesrc;
					// element.css('will-change', 'opacity');
					var imageonload = function(event) {
						cache.put(cachekey, imagesrc);
						isPreloading = false;
						preloadingURL = undefined;
						preloadingImage = undefined;
						loadImage(imagesrc);
						image.onload = undefined;
						image.onerror = undefined;
						image = undefined;
						srcfinalized = true;
					}
					if (!image.complete) {
						image.onload = imageonload;

					} else {
						imageonload();
						return;
					}

					image.onerror = function(event) {

						if (srcfinalized) { // 第二次錯誤, 連fallback都載入失敗
							image.onload = undefined;
							image.onerror = undefined;
							image = undefined;
							if (!cache.get(cachekey)) {
								cache.put(cachekey, 'about:blank');
							}
							isPreloading = false;
							preloadingURL = undefined;
							preloadingImage = undefined;
							enterViewportWatcher && enterViewportWatcher.destroy();
							return;
						}


						imagesrc = 'about:blank';
						var fallbackCallback = attrs.fallbackCallback;
						var fallbackImageUrl = scope.$eval(attrs.fallbackImageUrl);			

						if (fallbackImageUrl) 
							imagesrc = fallbackImageUrl;
						// console.log('imagesrc fallback to ' + imagesrc);
						// cache.put(cachekey, imagesrc);
						srcfinalized = true;
						image.src = imagesrc;

						if (fallbackCallback) {
							scope.$evalAsync(fallbackCallback);
						}
					};
				};

				var initZoomImage = function() {

					// 目前只處理bg image
					if(isBGImage) {
						var cupoyZoom = scope.$eval(attrs.cupoyZoom);
						var elePosition = element.css('position');
						var eleBgSize = element.css('background-size');
						var eleBgRepeat = element.css('background-repeat');
						var eleBgPosition = element.css('background-position');
						var $zoomCover = $('<div></div>');
						var $zoomLens = $('<div></div>');
						var $zoomWindow = $('<div></div>');
						var $zoomImage = $('<div></div>');
						var $spin;
						var zoomCoverWidth;
						var zoomCoverHeight;
						var zoomCoverOffset;
						var zoomLensWidth;
						var zoomLensHeight;
						var lensBoundX;
						var lensBoundY;
						var ratio = 2.5;

						if(!elePosition || elePosition == 'static') {
							element.css({
								'position': 'relative'
							});
						}

						var spinContent =  '' +
							'<div class="sk-three-bounce">' +
							    '<div class="sk-child sk-bounce1"></div>' +
								'<div class="sk-child sk-bounce2"></div>' +
							    '<div class="sk-child sk-bounce3"></div>' +
						    '</div>';

						$spin = $(spinContent);

						element.append($zoomCover);
						$zoomCover.append($zoomLens);
						$zoomWindow.append($zoomImage);
						$zoomWindow.append($spin);
						$('body').append($zoomWindow);


						$zoomCover.css({
						    'position': 'absolute',
						    'top': 0,
						    'left': 0,
						    'width': '100%',
						    'height': '100%',
						});

						$spin.css({
							'display': 'none',
							'position': 'absolute',
							'top': '50%',
							'left': '50%',
							'-moz-transform': 'translateX(-50%) translateY(-50%)',
							'-ms-transform': 'translateX(-50%) translateY(-50%)',
							'-webkit-transform': 'translateX(-50%) translateY(-50%)',
							'transform': 'translateX(-50%) translateY(-50%)',
						});

						var initImagePosAndSize = function() {

							zoomCoverWidth = $zoomCover.width();
							zoomCoverHeight = $zoomCover.height();
							zoomCoverOffset = undefined;
							zoomLensWidth = zoomCoverWidth / ratio;
							zoomLensHeight = zoomCoverHeight / ratio;

							$zoomLens.css({
								'display': 'none',
							    'position': 'absolute',
							    'width': zoomLensWidth,
							    'height': zoomLensHeight,
							    'border': '1px solid #000',
							    'border-radius': '3px',
							    'background-color': '#fff',
							    'pointer-events': 'none',
							    'opacity': '0.4',
							});

							$zoomWindow.css({
								'display': 'none',
							    'position': 'absolute',
							    'width': zoomCoverWidth,
							    'height': zoomCoverHeight,
							    'border': '3px solid #6a6a6a',
							    'overflow': 'hidden',
							    'z-index': 999999999,
							});

							$zoomImage.css({
								'position': 'absolute',
								'top': 0,
								'left': 0,
								'width': zoomCoverWidth * ratio,
								'height': zoomCoverHeight * ratio,
								'background-color': '#eee',
								'background-size': eleBgSize,
								'background-repeat': eleBgRepeat,
								'background-position': eleBgPosition,
							});

							lensBoundX = zoomCoverWidth - zoomLensWidth;
							lensBoundY = zoomCoverHeight - zoomLensHeight;
						}

						initImagePosAndSize();

						var offsetX;
						var offsetY;
						var lensX;
						var lensY;
						var winX;
						var winY;
						var isLoaded = false;

						$zoomCover.on('mousemove', function(event) {
							offsetX = event.offsetX;
							offsetY = event.offsetY;
							lensX = event.offsetX - zoomLensWidth / 2;
							lensY = event.offsetY - zoomLensHeight / 2;
							winX = lensX * ratio;
							winY = lensY * ratio;

							if(lensX < 0) {
								lensX = 0;
							} else if(lensX > lensBoundX) {
								lensX = lensBoundX;
							}

							if(lensY < 0) {
								lensY = 0;
							} else if(lensY > lensBoundY) {
								lensY = lensBoundY;
							}

							$zoomLens.css({
								'top': lensY,
								'left': lensX,
							});

							if(winX < 0) {
								winX = 0;
							} else if(winX > lensBoundX * ratio) {
								winX = lensBoundX * ratio;
							}

							if(winY < 0) {
								winY = 0;
							} else if(winY > lensBoundY * ratio) {
								winY = lensBoundY * ratio;
							}

							$zoomImage.css({
								'top': -winY,
								'left': -winX,
							});
						});

						$zoomCover.on('mouseenter', function(event) {

							if(!isLoaded) {
								$spin.css({
									'display': 'block',
								});

								$('<img/>').attr('src', cupoyZoom).on('load', function() {
								   	$(this).remove(); // prevent memory leaks as @benweet suggested
								   	$zoomImage.css({
								   		'background-image': 'url("'+ cupoyZoom +'")',
								   	});

								   	$spin.css({
								   		'display': 'none',
								   	});

								   	isLoaded = true;
								});
							}

							$zoomLens.css({
								'display': 'block',
							});

							zoomCoverOffset = zoomCoverOffset || $zoomCover.offset();

							$zoomWindow.css({
								'display': 'block',
							    'top': zoomCoverOffset.top,
							    'left': zoomCoverOffset.left + zoomCoverWidth + 5,
							});
						});

						$zoomCover.on('mouseleave', function(event) {
							$zoomLens.css({
								'display': 'none',
							});

							$zoomWindow.css({
								'display': 'none',
							});									
						});

						$(window).on('resize.cupoyimage' + cupoyImageId, initImagePosAndSize);

						scope.$on('$destroy', function() {
						    $zoomCover.remove();
						    $zoomLens.remove();
						    $zoomWindow.remove();
						    $zoomImage.remove();
						    $(window).off('resize.cupoyimage' + cupoyImageId);
						});
					}
				}
			}
		};
	}
])
.factory('cupoyImageURLCache', ['$cacheFactory', function($cacheFactory) {
	var cache = $cacheFactory('cupoyImageURLCache');
	return cache;
}]);